export default class FinesseSizeGuide extends HTMLElement {
  active: boolean = false
  tag: string = this.getAttribute('tag') || ''

  closeButton: HTMLElement | null = null
  container: HTMLElement | null = null

  constructor() {
    super()

    this.className = 'hidden flex w-full h-full fixed top-0 left-0 z-50'
  }

  connectedCallback() {
    this.closeButton = this.querySelector('button[data-close]')
    this.container = this.querySelector('aside[data-container]') as HTMLElement

    (window as any).addEventListener('sizeguide:toggle', this.handleSizeGuide.bind(this))

    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.handleClose)
    }

    if (this.container) {
      this.container.addEventListener('click', this.handleClose)
    }

    this.handleClose = this.handleClose.bind(this)
    this.handleSizeGuide = this.handleSizeGuide.bind(this)
  }

  get isActive() {
    return this.active
  }

  set isActive(value: boolean) {
    this.active = value
    this.setAttribute('active', value.toString())
    this.toggle()
  }

  handleClose = (evt: Event) => {
    evt.preventDefault()

    if (evt.target === this.container || evt.target === this.closeButton) {
      window.dispatchEvent(new CustomEvent('sizeguide:toggle', { bubbles: true, detail: { active: false, tag: `|${this.tag}|` } }))
    }
  }

  handleSizeGuide = (evt: CustomEvent) => {
    const tag = evt.detail.tag

    if (!tag.includes(this.tag)) {
      return
    }

    this.isActive = evt.detail.active
  }

  toggle() {
    if (this.isActive) {
      this.classList.remove('hidden')
      this.container?.classList.remove('opacity-0')
    } else {
      this.classList.add('hidden')
      this.container?.classList.add('opacity-0')
    }
  }
}

customElements.define('finesse-sizeguide', FinesseSizeGuide)
